import useFetch from "../../hooks/useFetch"

export default () => {
  const fetch = useFetch()

  const fetchRefreshShipping = async () => {
    const result = await fetch(`shipping/refresh`, { method: 'POST' })
    const resultJson = await result.json()
    const record = resultJson[0]
    return record
  }

  const fetchRefreshDates = async () => {
    const result = await fetch(`shipping/refresh`)
    const resultJson = await result.json()
    const record = resultJson[0]
    return record
  }

  return {
    fetchRefreshDates,
    fetchRefreshShipping
  }
}